import React from "react";
import { Popconfirm } from "antd";
import PRZButton from "../../UI/PRZButton";
import Rule from "./Rule";
import { v4 as uuidv4 } from "uuid";
import "./style.scss";

const RuleGroup = ({
  group,
  updateRuleGroup,
  removeRuleGroup,
  customFieldOptions,
}) => {
  const addRule = () => {
    const newRule = {
      id: uuidv4(),
      cf_entity_id: "",
      field_type: "",
      operator: "",
      values: [],
    };
    updateRuleGroup(group.id, {
      ...group,
      rules: [...group.rules, newRule],
    });
  };

  const updateRule = (ruleId, updatedRule) => {
    const updatedRules = group?.rules?.map((rule) =>
      rule.id === ruleId ? updatedRule : rule
    );
    updateRuleGroup(group?.id, { ...group, rules: updatedRules });
  };

  const removeRule = (ruleId) => {
    const updatedRules = group?.rules?.filter((rule) => rule?.id !== ruleId);
    updatedRules?.length === 0 ? removeRuleGroup(group?.id) : updateRuleGroup(group.id, { ...group, rules: updatedRules });
  };

  return (
    <div
      className="advance-filter__rule-group__wrapper"
    >
      {group.rules.map((rule, index) => (
        <Rule
          key={rule?.id}
          rule={rule}
          updateRule={(updatedRule) => updateRule(rule?.id, updatedRule)}
          removeRule={() => removeRule(rule?.id)}
          customFieldOptions={customFieldOptions}
          ruleIndex={index}
          groupType={group?.type}
        />
      ))}
      <div className="rule-group-button__wrapper">
        <PRZButton type="primary" onClick={addRule} className="rule-group-button">
          + And
        </PRZButton>
        <Popconfirm
          title="Are you sure you want to delete Rule Group?"
          onConfirm={removeRuleGroup}
          okText="Yes"
          cancelText="No"
        >
          <PRZButton type="default" danger>
            Remove Group
          </PRZButton>
        </Popconfirm>
      </div>
    </div>
  );
};

export default RuleGroup;
